<template>
  <div>

    <v-tabs v-model="activetab" align-with-title class="mt-n2 pb-0 tab-headers-details">
      <!-- eslint-disable-next-line max-len -->
      <v-tab v-for="tab of tabs" class="common-font-size" :key="tab.id" @click="WarnUser(tab.to)" :id="`mtgTransSequenceTab${tab.id}`"
        :class="`mtg-trans-sequence-tab-${tab.id}`">
        <span>{{ tab.caption }}</span>
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'PaymentAuditTab',
  // mixins: [CommonDropDownsMixin],
  components: {
  },
  created() {
    this.getPathName(this.$route.path);
  },
  data: () => ({
    dialog: false,
    path: '',
    activetab: 1,
    tabs: [
      { id: 1, to: { path: '/tax/payments/audit/list' }, caption: 'Approvals' },
      { id: 2, to: { path: '/tax/payments/audit/monthly-balance' }, caption: 'Monthly Balancing' },
      { id: 3, to: { path: '/tax/payments/audit/archived-reports' }, caption: 'Archived Reports' },
    ],
  }),
  methods: {

    getPathName(curPath) {
      const ftr = this.tabs.filter((ft) => ft.to.path === curPath);
      this.activetab = ftr[0].id !== undefined ? ftr[0].id - 1 : 0;
    },
    WarnUser(path) {
      this.path = path;
      const currentpath = this.$router.currentRoute.path;
      if (path.path !== currentpath) {
        this.$router.push(path);
      }
    },

  },

};
</script>
